import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Check } from "@mui/icons-material";

import messages from "../../../../../../../assets/locale/messages";
import Button from "../../../../../../../components/Button";
import Modal from "../../../../../../../components/Modal";
import { approveVerificationRequest } from "../../../../../../../store/BusinessVerification/actions";
import { BlueBoxBgIcon } from "../../../../../../../utils/Icons";

const ApproveRequest = ({ requestType }) => {
  const dispatch = useDispatch();

  const lang = useSelector((state) => state.locale.lang);
  const {
    businessVerification: {
      actions: { approveRequest }
    },
    shared
  } = messages[lang];

  const requestDetails = useSelector(
    (state) => state.businessVerification.verificationRequestMainInfo
  );

  const [modalOpen, setModalOpen] = useState(false);

  const handleAcceptDocs = () => {
    dispatch(
      approveVerificationRequest({
        data: { Id: requestDetails?.Id },
        requestType
      })
    );
    setModalOpen(false);
  };

  return (
    <div className="approve-documents">
      <Button
        label={
          <>
            <Check className="me-2" />
            {approveRequest.btnLabel}
          </>
        }
        success
        onClick={() => setModalOpen(true)}
      />
      {modalOpen && (
        <Modal
          open={modalOpen}
          icon={<BlueBoxBgIcon />}
          title={approveRequest.title.replace(
            ":companyName",
            requestDetails?.CompanyName || ""
          )}
          content={approveRequest.confirmMsg}
          confirmBtnTxt={shared.accept}
          cancelBtnTxt={shared.cancel}
          handleClose={() => setModalOpen(false)}
          handleCancel={() => setModalOpen(false)}
          handleConfirm={handleAcceptDocs}
        />
      )}
    </div>
  );
};

export default ApproveRequest;

ApproveRequest.propTypes = {
  requestType: PropTypes.number.isRequired
};
